export default __webpack_public_path__ + "static/media/copyIcon.91917811.svg";